@if (showCreateCanvasModal()) {
    <router-outlet></router-outlet>
} @else {
    <section class="px-6 pt-6" [class.blur-[2px]]="showCreateCanvasModal()">
    <div class="mb-8">
        <h1 class="text-3xl font-bold mb-2">Canvases</h1>
        <p class="text-sm text-[#475467]">All your canvases live here</p>
    </div>

    @if (loadingCanvases()) {
      <ui-skeleton-assets />
    } @else {
      @if (!canvases().length) {
        <div class="flex flex-col items-center py-32">
            <div class="mb-4 w-44">
            <img src="assets/img/clouds.svg" alt="" class="w-full h-auto" />
            </div>
            <p class="text-xl font-bold mb-2">No canvases found</p>
            <p class="mb-8 text-center">
            Seems you have no canvases made on your account. Click the<br />
            button to add one.
            </p>
            <button (click)="setShowCreateCanvasModal(true)"
            class="flex items-center text-md border border-[#7F56D9] rounded-lg py-2 px-4 bg-[#0F49A0] hover:bg-[#0f4ea0] transition text-white font-medium">
            <img src="assets/icons/plus.svg"  alt="" class="mr-3" />
            Add a canvas
            </button>
        </div>
      } @else {
        <div class="flex flex-col md:flex-row items-center justify-between mb-6 p-4 bg-gray-50 rounded-lg shadow">
          <div>
            <div class="flex items-center mb-1">
              <p class="mr-3 font-bold text-xl text-gray-700">Total Canvases</p>
              <span class="h-[26px] inline-flex items-center text-sm rounded-full bg-indigo-100 text-indigo-700 px-4 py-1 font-medium">
              {{ canvases().length }}  {{ canvases().length === 1 ? 'canvas' : 'canvases' }}
              </span>
            </div>
            <p class="text-sm text-gray-500">Keep track of your active connections.</p>
          </div>
          <button (click)="openCreateCanvasModal()"
            class="mt-4 md:mt-0 flex items-center text-md rounded-lg py-2.5 px-5 text-white font-medium bg-gradient-to-r from-[#0575E6] to-[#021B79] hover:bg-[#0575E6] transition-all duration-300 ease-in-out">
            <img src="assets/icons/plus.svg" alt="" class="mr-3" />
            Add New Canvas
          </button>
        </div>
        <app-assets-flat-list-table
          [assetType]="assetType"
          (showManageAssetModal)="setShowManageCanvasModal(true)"
          [assetsInput]="canvases()"
          (refreshAssets)="getCanvases()"
          (onEditActionEmt)="handleEditAction($event)"
          (onAssetDelete)="handleDeleteAction($event)"
          />
      }
    }
    </section>
}